import { RadioButton } from "primereact/radiobutton";
import { IconMode } from "./icon";
import "./SelectMode.scss";
import { ControllerRenderProps } from 'react-hook-form';
import { RuntimeMode } from '../../app/appSlice';
import { useTranslation } from 'react-i18next';
import { FormFields } from '../../pages/treatments/NewTopologyForm';

interface ISelectMode {
  field:  ControllerRenderProps<FormFields, 'mode'>;
  runtime: RuntimeMode;
}

export const SelectMode = ({
  field,
  runtime
}: ISelectMode) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="selectMode"
        style={{
          border: field.value === runtime.name
            ? "solid 0.15rem #007eae"
            : "solid 0.15rem #dfe7ef",
          backgroundColor: field.value === runtime.name ? " #f0f7fa" : "#FFFFFF",
        }}
        onClick={() => {
          field.onChange(runtime.name);
        }}
      >
        <div className="grid mt-1">
          <div className="p-field col-1 flex justify-content-end align-items-center">
            <RadioButton
              name="mode"
              value={runtime.name}
              onChange={() => {
                field.onChange(runtime.name);
              }}
              checked={field.value === runtime.name}
            />
          </div>
          <div className="p-field col-9 flex flex-column ">
          <div className="ml-4 font-bold">{t(`topology.${runtime.name}`)}</div>

            {runtime.description.length > 0 && (
              <ul>
                {runtime.description.map((description, index) => (
                  <li key={index}>{description}</li>
                ))}
              </ul>
            )}
          </div>

          <div className="p-field col-2 flex justify-content-center align-items-center">
            <div className="lineBeforeIcon"></div>
            <IconMode
              color={runtime.icon.color}
              name={runtime.name}
              fontSize="2rem"
              type={runtime.icon.type}
              key={runtime.icon.type}
            ></IconMode>
          </div>
        </div>
      </div>
    </>
  );
};
